/**
 * @generated SignedSource<<d63ba0ffcc80b6f78b7471f52c7b1d56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bookingId",
        "variableName": "bookingId"
      }
    ],
    "concreteType": "TicketSentType",
    "kind": "LinkedField",
    "name": "sendTicketToWa",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendTicketToWattsappQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendTicketToWattsappQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "71651b7731de35735a04c49f56e01916",
    "id": null,
    "metadata": {},
    "name": "SendTicketToWattsappQuery",
    "operationKind": "query",
    "text": "query SendTicketToWattsappQuery(\n  $bookingId: String!\n) {\n  sendTicketToWa(bookingId: $bookingId) {\n    message\n    status\n  }\n}\n"
  }
};
})();

node.hash = "9a5ef399d4ad5b0bf904703da25a228b";

module.exports = node;
